let _ready = false

export const ready = () => {
  _ready = true
}

export default () => {
  return _ready
}
